import {
  Button,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalSection,
} from '@axiom/ui';
import React from 'react';

import { SyncOpportunityApi } from '../../api/sync-opportunity-api';
import { OpportunityLegacyApi } from '../../api/opportunity-legacy-api';
import { PreloadedAppErrorsStore } from '../../stores/preloaded-app-errors-store';
import { OpportunityStore } from '../../stores/opportunity-store';

export const OpportunityProfileHeaderSyncModal = ({
  opportunityId,
  onClose,
}: {
  opportunityId: string;
  onClose: () => void;
}) => {
  return (
    <Modal name="opportunity_sync_modal">
      <ModalHeader onClose={onClose} name="opportunity_sync_modal">
        Are you sure you want to create this Opportunity in Salesforce?
      </ModalHeader>
      <ModalSection>
        The client will not be able to edit their requirements or get new self
        service matches after this point.
      </ModalSection>
      <ModalFooter>
        <Button
          name="opp_sync_cancel_button"
          onClick={onClose}
          variation="outline"
        >
          Cancel
        </Button>
        <Button
          name="opp_sync_confirm_button"
          onClick={async () => {
            onClose();
            try {
              await SyncOpportunityApi.createSync(opportunityId);
              await Promise.all([
                OpportunityLegacyApi.refreshOpportunity(opportunityId),
                OpportunityStore.load(opportunityId),
              ]);
            } catch {
              PreloadedAppErrorsStore.show(
                'Creating SalesForce Opportunity failed. Please refresh and try again later.'
              );
            }
          }}
        >
          Confirm
        </Button>
      </ModalFooter>
    </Modal>
  );
};
